import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["id"]
const _hoisted_3 = {
  key: 0,
  class: "section-tools-below"
}
const _hoisted_4 = ["id"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "text-left"
}
const _hoisted_7 = {
  key: 1,
  class: "text-left"
}
const _hoisted_8 = {
  key: 2,
  class: "unlink-col"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "accent-col" }
const _hoisted_11 = {
  key: 0,
  class: "ontos-list-name"
}
const _hoisted_12 = {
  key: 1,
  class: "second-col"
}
const _hoisted_13 = {
  key: 2,
  class: "unlink-col"
}
const _hoisted_14 = {
  key: 1,
  class: "text-body-2 text-grey px-2 py-1"
}
const _hoisted_15 = {
  key: 2,
  class: "px-2 py-1"
}
const _hoisted_16 = {
  key: 4,
  class: "ontos-inset mb-3"
}
const _hoisted_17 = {
  key: 1,
  class: "instance-authorship ontos-arrives text-caption text-medium-emphasis"
}
const _hoisted_18 = ["title"]
const _hoisted_19 = { class: "authorship-name" }
const _hoisted_20 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_header_action = _resolveComponent("ontos-header-action")!
  const _component_ontos_page_header = _resolveComponent("ontos-page-header")!
  const _component_ontos_state_seal = _resolveComponent("ontos-state-seal")!
  const _component_ontos_relationship_add = _resolveComponent("ontos-relationship-add")!
  const _component_ontos_show_closed_toggle = _resolveComponent("ontos-show-closed-toggle")!
  const _component_ontos_view_tabs = _resolveComponent("ontos-view-tabs")!
  const _component_ontos_field_failures = _resolveComponent("ontos-field-failures")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_ontos_instance_list_row = _resolveComponent("ontos-instance-list-row")!
  const _component_ontos_color_accent = _resolveComponent("ontos-color-accent")!
  const _component_ontos_instance_identifier = _resolveComponent("ontos-instance-identifier")!
  const _component_ontos_property_value = _resolveComponent("ontos-property-value")!
  const _component_ontos_colored_option = _resolveComponent("ontos-colored-option")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_ontos_table_fit = _resolveComponent("ontos-table-fit")!
  const _component_ontos_hidden_count = _resolveComponent("ontos-hidden-count")!
  const _component_ontos_relationship_board = _resolveComponent("ontos-relationship-board")!
  const _component_markdown_viewer = _resolveComponent("markdown-viewer")!
  const _component_ontos_related_item_line = _resolveComponent("ontos-related-item-line")!
  const _component_ontos_instance_fields = _resolveComponent("ontos-instance-fields")!
  const _component_ontos_dialog_loading = _resolveComponent("ontos-dialog-loading")!
  const _component_ontos_tabbed_section = _resolveComponent("ontos-tabbed-section")!
  const _component_ontos_user_avatar = _resolveComponent("ontos-user-avatar")!
  const _component_ontos_state_dialog = _resolveComponent("ontos-state-dialog")!
  const _component_ontos_delete_instance_dialog = _resolveComponent("ontos-delete-instance-dialog")!
  const _component_ontos_relationship_unlink_dialog = _resolveComponent("ontos-relationship-unlink-dialog")!
  const _component_ontos_image_preview_dialog = _resolveComponent("ontos-image-preview-dialog")!
  const _component_ontos_base = _resolveComponent("ontos-base")!
  const _directive_smooth_height = _resolveDirective("smooth-height")!

  return (_openBlock(), _createBlock(_component_ontos_base, _mergeProps(_ctx.baseProps, {
    ref: "base",
    "phone-flush": _ctx.framed
  }), {
    default: _withCtx(() => [
      (_ctx.loaded)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.framed ? 'ontos-instance-card' : 'div'), {
              class: _normalizeClass(_ctx.framed ? 'instance-sheet' : '')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ontos_page_header, _normalizeProps(_guardReactiveProps(_ctx.heading)), _createSlots({
                  actions: _withCtx(() => [
                    (_ctx.complete && _ctx.canEditItem(_ctx.instance))
                      ? (_openBlock(), _createBlock(_component_ontos_header_action, {
                          key: 0,
                          icon: "mdi-pencil",
                          label: _ctx.$tt('edit'),
                          color: "primary",
                          onClick: _ctx.onEdit
                        }, null, 8, ["label", "onClick"]))
                      : _createCommentVNode("", true),
                    (_ctx.complete && _ctx.canDeleteItem(_ctx.instance))
                      ? (_openBlock(), _createBlock(_component_ontos_header_action, {
                          key: 1,
                          icon: "mdi-delete",
                          label: _ctx.$tt('delete'),
                          color: "error",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOnDelete = true))
                        }, null, 8, ["label"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, [
                  (_ctx.$slots.controls)
                    ? {
                        name: "controls",
                        fn: _withCtx(() => [
                          _renderSlot(_ctx.$slots, "controls", { idea: _ctx.idea }, undefined, true)
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1040),
                (_ctx.workflow)
                  ? (_openBlock(), _createBlock(_component_ontos_state_seal, {
                      key: 0,
                      class: "mb-4",
                      state: _ctx.workflow.coloredStateOf(_ctx.instance),
                      since: _ctx.instance._stateChangedAt || '',
                      changeable: _ctx.complete && _ctx.canEditItem(_ctx.instance),
                      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isOnStateChange = true))
                    }, null, 8, ["state", "since", "changeable"]))
                  : _createCommentVNode("", true),
                _withDirectives((_openBlock(), _createBlock(_component_ontos_tabbed_section, {
                  tabs: _ctx.sectionTabs,
                  opens: _ctx.sectionTabs[0].value,
                  routed: _ctx.framed,
                  "plain-controls": ""
                }, {
                  controls: _withCtx(({ tab }) => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([_ctx.shownSection(tab)], (section) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: section.key
                      }, [
                        (_ctx.addsTo(section) && _ctx.viewOf(section) !== 'kanban')
                          ? (_openBlock(), _createBlock(_component_ontos_relationship_add, _mergeProps({
                              key: 0,
                              ref_for: true
                            }, _ctx.addProps(section), {
                              onAdded: ($event: any) => (_ctx.onRelationshipAdded(section, $event)),
                              onShowMessage: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('showMessage', $event))),
                              onShowErrorMessage: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('showErrorMessage', $event)))
                            }), null, 16, ["onAdded"]))
                          : (_ctx.addsTo(section) && _ctx.$vuetify.display.xs)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                id: _ctx.boardAddId
                              }, null, 8, _hoisted_1))
                            : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ]),
                  tools: _withCtx(({ tab }) => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([_ctx.shownSection(tab)], (section) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: section.key
                      }, [
                        (!_ctx.$vuetify.display.xs)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (_ctx.hasKanban(section) && _ctx.viewOf(section) === 'kanban')
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    id: _ctx.boardHeaderId
                                  }, null, 8, _hoisted_2))
                                : _createCommentVNode("", true),
                              (_ctx.showsClosedToggle(section))
                                ? (_openBlock(), _createBlock(_component_ontos_show_closed_toggle, {
                                    key: 1,
                                    modelValue: _ctx.isShowClosedItems[section.key],
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.isShowClosedItems[section.key]) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true),
                        (_ctx.hasKanban(section))
                          ? (_openBlock(), _createBlock(_component_ontos_view_tabs, {
                              key: 1,
                              views: _ctx.viewTabs,
                              "model-value": _ctx.viewOf(section),
                              "onUpdate:modelValue": ($event: any) => (_ctx.onViewChange(section, $event))
                            }, null, 8, ["views", "model-value", "onUpdate:modelValue"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ]),
                  default: _withCtx(({ tab }) => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([_ctx.shownSection(tab)], (section) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: section.key
                      }, [
                        (_ctx.$vuetify.display.xs && (_ctx.viewOf(section) === 'kanban' && _ctx.hasKanban(section) || _ctx.showsClosedToggle(section)))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                              (_ctx.hasKanban(section) && _ctx.viewOf(section) === 'kanban')
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    id: _ctx.boardHeaderId
                                  }, null, 8, _hoisted_4))
                                : _createCommentVNode("", true),
                              (_ctx.showsClosedToggle(section))
                                ? (_openBlock(), _createBlock(_component_ontos_show_closed_toggle, {
                                    key: 1,
                                    modelValue: _ctx.isShowClosedItems[section.key],
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.isShowClosedItems[section.key]) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.sectionFailures(section).length)
                          ? (_openBlock(), _createBlock(_component_ontos_field_failures, {
                              key: 1,
                              failures: _ctx.sectionFailures(section),
                              class: "mb-2"
                            }, null, 8, ["failures"]))
                          : _createCommentVNode("", true),
                        (!_ctx.isPending(section))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              (section.table && _ctx.viewOf(section) === 'list' && _ctx.rowsOf(section).length)
                                ? (_openBlock(), _createBlock(_component_ontos_table_fit, { key: 0 }, {
                                    default: _withCtx(({ compact }) => [
                                      compact
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rowsOf(section), (item) => {
                                              return (_openBlock(), _createBlock(_component_ontos_instance_list_row, {
                                                key: item._instance,
                                                class: "compact-list-row",
                                                instance: item,
                                                idea: section.idea,
                                                fields: _ctx.relRowFields(section, item),
                                                state: _ctx.relRowState(section, item),
                                                context: _ctx.rowContext(section, item),
                                                "choice-domains": _ctx.workspace.domains,
                                                onClick: _withModifiers(($event: any) => (_ctx.openRow(section, item)), ["stop"])
                                              }, _createSlots({ _: 2 }, [
                                                (_ctx.unlinksFrom(section))
                                                  ? {
                                                      name: "actions",
                                                      fn: _withCtx(() => [
                                                        _createVNode(_component_v_btn, {
                                                          variant: "text",
                                                          icon: "",
                                                          size: "x-small",
                                                          class: "unlink-btn",
                                                          title: _ctx.$tt('relationship-unlink'),
                                                          onClick: _withModifiers(($event: any) => (_ctx.askUnlink(section, item)), ["stop"])
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_icon, { size: "x-small" }, {
                                                              default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                                                _createTextVNode("mdi-close", -1)
                                                              ]))]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        }, 8, ["title", "onClick"])
                                                      ]),
                                                      key: "0"
                                                    }
                                                  : undefined
                                              ]), 1032, ["instance", "idea", "fields", "state", "context", "choice-domains", "onClick"]))
                                            }), 128))
                                          ]))
                                        : (_openBlock(), _createBlock(_component_v_table, {
                                            key: 1,
                                            class: "custom-table ontos-list-table",
                                            hover: ""
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("thead", null, [
                                                _createElementVNode("tr", null, [
                                                  _cache[23] || (_cache[23] = _createElementVNode("th", { class: "accent-col" }, null, -1)),
                                                  (_ctx.hasCompositeIdentifier(section.idea))
                                                    ? (_openBlock(), _createElementBlock("th", _hoisted_6, _toDisplayString(section.idea.name), 1))
                                                    : _createCommentVNode("", true),
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relProperties(section), (relProperty) => {
                                                    return (_openBlock(), _createElementBlock("th", {
                                                      class: "text-left",
                                                      key: `${section.key}.${relProperty.alias}`
                                                    }, _toDisplayString(relProperty.name), 1))
                                                  }), 128)),
                                                  (section.idea.workflow)
                                                    ? (_openBlock(), _createElementBlock("th", _hoisted_7, _toDisplayString(_ctx.$tt('state')), 1))
                                                    : _createCommentVNode("", true),
                                                  (_ctx.unlinksFrom(section))
                                                    ? (_openBlock(), _createElementBlock("th", _hoisted_8))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ]),
                                              _createElementVNode("tbody", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rowsOf(section), (item) => {
                                                  return (_openBlock(), _createElementBlock("tr", {
                                                    key: item._instance,
                                                    class: "clickable-row ontos-list-row",
                                                    onClick: _withModifiers(($event: any) => (_ctx.openRow(section, item)), ["stop"])
                                                  }, [
                                                    _createElementVNode("td", _hoisted_10, [
                                                      _createVNode(_component_ontos_color_accent, {
                                                        row: "",
                                                        color: _ctx.instanceColorOf(item)
                                                      }, null, 8, ["color"])
                                                    ]),
                                                    (_ctx.hasCompositeIdentifier(section.idea))
                                                      ? (_openBlock(), _createElementBlock("td", _hoisted_11, [
                                                          _createVNode(_component_ontos_instance_identifier, {
                                                            instance: item,
                                                            idea: section.idea
                                                          }, null, 8, ["instance", "idea"])
                                                        ]))
                                                      : _createCommentVNode("", true),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relProperties(section), (relProperty) => {
                                                      return (_openBlock(), _createElementBlock("td", {
                                                        class: _normalizeClass(["first-col", {'ontos-list-name': relProperty.identifier && !_ctx.hasCompositeIdentifier(section.idea)}]),
                                                        key: `value.${section.key}.${relProperty.alias}`
                                                      }, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.propertyValueArrayGeneric(item, relProperty), (simpleValue, i) => {
                                                          return (_openBlock(), _createBlock(_component_ontos_property_value, {
                                                            key: `${section.key}.${relProperty.alias}[${i}]`,
                                                            property: relProperty,
                                                            value: simpleValue,
                                                            item: item,
                                                            context: _ctx.rowContext(section, item),
                                                            "choice-domains": _ctx.workspace.domains,
                                                            variant: "cell",
                                                            onPreview: _cache[4] || (_cache[4] = ($event: any) => (_ctx.imagePreview = $event)),
                                                            onLink: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onInstanceLink($event.event, $event.context)))
                                                          }, null, 8, ["property", "value", "item", "context", "choice-domains"]))
                                                        }), 128))
                                                      ], 2))
                                                    }), 128)),
                                                    (_ctx.relRowState(section, item))
                                                      ? (_openBlock(), _createElementBlock("td", _hoisted_12, [
                                                          _createVNode(_component_ontos_colored_option, {
                                                            option: _ctx.relRowState(section, item)!,
                                                            dot: ""
                                                          }, null, 8, ["option"])
                                                        ]))
                                                      : _createCommentVNode("", true),
                                                    (_ctx.unlinksFrom(section))
                                                      ? (_openBlock(), _createElementBlock("td", _hoisted_13, [
                                                          _createVNode(_component_v_btn, {
                                                            variant: "text",
                                                            icon: "",
                                                            size: "x-small",
                                                            class: "unlink-btn",
                                                            title: _ctx.$tt('relationship-unlink'),
                                                            onClick: _withModifiers(($event: any) => (_ctx.askUnlink(section, item)), ["stop"])
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_v_icon, { size: "x-small" }, {
                                                                default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                                                                  _createTextVNode("mdi-close", -1)
                                                                ]))]),
                                                                _: 1
                                                              })
                                                            ]),
                                                            _: 1
                                                          }, 8, ["title", "onClick"])
                                                        ]))
                                                      : _createCommentVNode("", true)
                                                  ], 8, _hoisted_9))
                                                }), 128))
                                              ])
                                            ]),
                                            _: 2
                                          }, 1024))
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              (_ctx.viewOf(section) === 'list' && _ctx.emptySection(section))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.$tt('relationship-empty', {relationship: section.path})), 1))
                                : _createCommentVNode("", true),
                              (section.property && _ctx.hiddenCount(_ctx.instance, section.property))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                    _createVNode(_component_ontos_hidden_count, {
                                      count: _ctx.hiddenCount(_ctx.instance, section.property)
                                    }, null, 8, ["count"])
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.hasKanban(section) && _ctx.viewOf(section) === 'kanban')
                                ? (_openBlock(), _createBlock(_component_ontos_relationship_board, {
                                    key: 3,
                                    flush: "",
                                    "header-to": `#${_ctx.boardHeaderId}`,
                                    "add-to": _ctx.$vuetify.display.xs ? `#${_ctx.boardAddId}` : '',
                                    "owner-context": _ctx.context,
                                    owner: _ctx.instance,
                                    property: section.property,
                                    "reverse-info": _ctx.reverseInfo,
                                    workspace: _ctx.workspace,
                                    "reload-owner": _ctx.reloadOwner,
                                    domains: _ctx.relDomains,
                                    editable: _ctx.addsTo(section),
                                    "known-candidates": _ctx.candidatesOf(section),
                                    "onUpdate:owner": _cache[6] || (_cache[6] = ($event: any) => (_ctx.onOwnerChanged($event))),
                                    onCandidates: ($event: any) => (_ctx.rememberCandidates(section, $event)),
                                    onOpenInstance: _ctx.openBoardItem,
                                    onChanged: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onBoardChanged())),
                                    onNoDimensions: ($event: any) => (_ctx.onViewChange(section, 'list')),
                                    onShowMessage: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('showMessage', $event))),
                                    onShowErrorMessage: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('showErrorMessage', $event)))
                                  }, {
                                    title: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                      _createElementVNode("span", null, null, -1)
                                    ]))]),
                                    controls: _withCtx(() => [
                                      _createVNode(_component_ontos_header_action, {
                                        icon: "mdi-open-in-new",
                                        label: _ctx.$tt('expand'),
                                        to: _ctx.relationshipRoute(section)
                                      }, null, 8, ["label", "to"])
                                    ]),
                                    _: 2
                                  }, 1032, ["header-to", "add-to", "owner-context", "owner", "property", "reverse-info", "workspace", "reload-owner", "domains", "editable", "known-candidates", "onCandidates", "onOpenInstance", "onNoDimensions"]))
                                : _createCommentVNode("", true),
                              (section.markdown)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.asArray(section.instance[section.markdown.alias]), (value, index) => {
                                      return (_openBlock(), _createBlock(_component_markdown_viewer, {
                                        key: index,
                                        initialValue: _ctx.shownMarkdown(value, _ctx.workspace, section.instance, _ctx.context.idea)
                                      }, null, 8, ["initialValue"]))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true),
                              (section.property && !section.table)
                                ? (_openBlock(), _createBlock(_component_ontos_related_item_line, {
                                    key: 5,
                                    property: section.property,
                                    item: section.instance,
                                    context: _ctx.context,
                                    onLink: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onInstanceLink($event.event, $event.context)))
                                  }, null, 8, ["property", "item", "context"]))
                                : _createCommentVNode("", true),
                              (!section.table && !section.markdown)
                                ? (_openBlock(), _createBlock(_component_ontos_instance_fields, {
                                    key: 6,
                                    properties: section.properties,
                                    instance: section.instance,
                                    context: _ctx.context,
                                    "choice-domains": _ctx.workspace.domains,
                                    onPreview: _cache[11] || (_cache[11] = ($event: any) => (_ctx.imagePreview = $event)),
                                    onLink: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onInstanceLink($event.event, $event.context)))
                                  }, null, 8, ["properties", "instance", "context", "choice-domains"]))
                                : _createCommentVNode("", true)
                            ], 64))
                          : (_openBlock(), _createBlock(_component_ontos_dialog_loading, {
                              key: 3,
                              "min-height": "96px"
                            }))
                      ], 64))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["tabs", "opens", "routed"])), [
                  [_directive_smooth_height]
                ]),
                (_ctx.complete && _ctx.authorship.length)
                  ? (_openBlock(), _createElementBlock("footer", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.authorship, (author) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: author.key,
                          class: "authorship-entry",
                          title: author.exact
                        }, [
                          _createTextVNode(_toDisplayString(author.label) + " ", 1),
                          (author.person)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createVNode(_component_ontos_user_avatar, {
                                  user: author.person.user,
                                  label: _ctx.personName(author.person),
                                  photo: author.person.photo,
                                  size: 18
                                }, null, 8, ["user", "label", "photo"]),
                                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.personName(author.person)), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (author.when)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(author.when), 1))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_18))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 3
            }, 8, ["class"])), [
              [_directive_smooth_height]
            ]),
            (_ctx.isOnStateChange && _ctx.workflow)
              ? (_openBlock(), _createBlock(_component_ontos_state_dialog, {
                  key: 0,
                  heading: _ctx.editHeading,
                  field: _ctx.$tt('state'),
                  form: "dot",
                  options: _ctx.workflow.coloredStates(),
                  current: _ctx.currentState.id,
                  onPick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onPickState($event))),
                  onClosed: _cache[14] || (_cache[14] = ($event: any) => (_ctx.isOnStateChange = false))
                }, null, 8, ["heading", "field", "options", "current"]))
              : _createCommentVNode("", true),
            (_ctx.isOnDelete)
              ? (_openBlock(), _createBlock(_component_ontos_delete_instance_dialog, {
                  key: 1,
                  context: _ctx.context,
                  identifier: _ctx.instance._identifier,
                  "idea-name": _ctx.idea.name,
                  onConfirmed: _ctx.onDeleteConfirmed,
                  onOpenInstance: _cache[15] || (_cache[15] = ($event: any) => (_ctx.openInstance($event, true))),
                  onClosed: _cache[16] || (_cache[16] = ($event: any) => (_ctx.isOnDelete = false)),
                  onShowErrorMessage: _cache[17] || (_cache[17] = ($event: any) => (_ctx.$emit('showErrorMessage', $event)))
                }, null, 8, ["context", "identifier", "idea-name", "onConfirmed"]))
              : _createCommentVNode("", true),
            (_ctx.unlinking)
              ? (_openBlock(), _createBlock(_component_ontos_relationship_unlink_dialog, {
                  key: 2,
                  "owner-context": _ctx.context,
                  owner: _ctx.instance,
                  property: _ctx.unlinking.section.property,
                  item: _ctx.unlinking.item,
                  workspace: _ctx.workspace,
                  onUnlinked: _cache[18] || (_cache[18] = ($event: any) => (_ctx.onUnlinked($event))),
                  onClosed: _cache[19] || (_cache[19] = ($event: any) => (_ctx.unlinking = null)),
                  onShowMessage: _cache[20] || (_cache[20] = ($event: any) => (_ctx.$emit('showMessage', $event)))
                }, null, 8, ["owner-context", "owner", "property", "item", "workspace"]))
              : _createCommentVNode("", true),
            (_ctx.imagePreview)
              ? (_openBlock(), _createBlock(_component_ontos_image_preview_dialog, {
                  key: 3,
                  src: _ctx.imagePreview.src,
                  title: _ctx.imagePreview.title,
                  onClosed: _cache[21] || (_cache[21] = ($event: any) => (_ctx.imagePreview = null))
                }, null, 8, ["src", "title"]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 16, ["phone-flush"]))
}